import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { UserTypes } from '@site-mate/dashpivot-shared-library';

import { TmpI18NService } from 'app/i18n/tmp-i18n.service';
import { AppUtilService } from 'app/shared/service/app-util.service';
import { UserInvite } from 'app/users/user-invite.model';

@Component({
  selector: 'cc-user-invite',
  templateUrl: './user-invite.component.html',
  styleUrls: ['./user-invite.component.scss'],
})
export class UserInviteComponent implements OnInit {
  @Input() model: UserInvite;

  @Input() userType: UserTypes;

  @ViewChild('form')
  form: NgForm;

  @Output()
  readonly inviteUser = new EventEmitter<void>();

  emailRegex: RegExp;
  differentUserTypeErrorMessages: { [key: string]: string };

  constructor(private readonly appUtilService: AppUtilService, private readonly i18n: TmpI18NService) {}

  ngOnInit(): void {
    this.emailRegex = this.appUtilService.emailRegex;
    this.setDifferentUserTypeErrorMessages();
  }

  private setDifferentUserTypeErrorMessages() {
    this.differentUserTypeErrorMessages = {
      [UserTypes.Contributor]: this.i18n.getMessage('inviteContributorTypeError'),
      [UserTypes.Visitor]: this.i18n.getMessage('inviteVisitorsTypeError'),
    };
  }

  onInviteUser(): void {
    this.model.submitted = true;
    if (this.form.valid) {
      this.inviteUser.emit();
    }
  }

  resetSubmission(event: KeyboardEvent) {
    const isEnterKey = event.code === 'Enter';
    if (this.model.submitted && !isEnterKey) {
      this.model.isExistingUser = false;
      this.model.isWorkplaceDomain = false;
      this.model.isPublicDomain = false;
      this.model.isExistingUserDifferentType = false;
      this.model.submitted = false;
    }
  }
}
